import { RevealSection } from "../motion/RevealSection";

export const HighlightsGrid = ({ items }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
    {items.map((item, idx) => (
      <RevealSection key={item.title} delay={idx * 0.08} className="border border-white/10 p-6 md:p-8">
        <h3 className="font-serif-display text-xl md:text-2xl text-twp-gold mb-3">{item.title}</h3>
        <p className="text-white/70 text-sm">{item.description}</p>
      </RevealSection>
    ))}
  </div>
);
